import { Helmet } from "react-helmet-async";
import { SITE_URL, OG_IMAGE, getRouteMeta } from "@/lib/seo";

// SEO per-pagina: title/description/canonical univoci + Open Graph di base.
// - route: path pubblico presente in publicRoutes.json (usa i suoi title/description)
// - noindex: pagine transazionali/private (niente canonical, robots noindex)
export const Seo = ({ route, title, description, noindex = false }) => {
  const meta = route ? getRouteMeta(route) : null;
  const t = title || meta?.title || "iPhix Scafati";
  const d = description || meta?.description || "";
  const path = route || meta?.path || "/";
  const canonical = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <html lang="it" />
      <title>{t}</title>
      {d && <meta name="description" content={d} />}
      <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow"} />
      {!noindex && <link rel="canonical" href={canonical} />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="iPhix Scafati" />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:title" content={t} />
      {d && <meta property="og:description" content={d} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={OG_IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      {d && <meta name="twitter:description" content={d} />}
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
};
